import { observer } from "mobx-react-lite"

import type { WithdrawStore } from "@/domains/lock-page/withdraw-store"
import { ExternalTxLink } from "@/domains/common/components/external-tx-link"
import { MessageBoxIcon } from "@/domains/common/components/message-box-icon"
import { MultilineMessageBox } from "@/domains/common/components/multi-line-message-box"
import { ShortMessageBox } from "@/domains/common/components/short-message-box"
import { BodySM } from "@/domains/design/components/body-sm"

interface WithdrawWithdrawFailedProps {
  store: WithdrawStore
}

export const WithdrawWithdrawFailed = observer(({ store }: WithdrawWithdrawFailedProps) => {
  return (
    <MultilineMessageBox variant="error" icon={<MessageBoxIcon size={"md"} variant="error" />}>
      <BodySM className="mt-[3px] text-error-text">Withdraw failed, Please try again:</BodySM>
      <BodySM className="my-5 rounded-md border border-error-background/20 bg-error-background/[0.15] px-4 py-2 text-error-text">
        {store.withdrawError ?? "Unknown error"}
      </BodySM>
      {store.resetTxHash && <ExternalTxLink url={store.resetTxHashUrl} title="View reset tx" />}
    </MultilineMessageBox>
  )
})
